import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=96e8ac1a&scoped=true&"
import script from "./Remark.vue?vue&type=script&lang=js&"
export * from "./Remark.vue?vue&type=script&lang=js&"
import style0 from "./Remark.vue?vue&type=style&index=0&id=96e8ac1a&lang=less&scoped=true&"
import style1 from "./Remark.vue?vue&type=style&index=1&id=96e8ac1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e8ac1a",
  null
  
)

export default component.exports